import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialItemTemplate: ITrialItemTemplateLoadActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_LOAD,
            trialId
        }
    },
    LoadTrialItemTemplateById: ITrialItemTemplateLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialItemTemplateLoadSuccessActionCreator = (formData, formDataTrialed, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS,
            formData,
            formDataTrialed,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialItemTemplateLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialItemTemplate: ITrialItemTemplateSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: ITrialItemTemplateSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialItemTemplateSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialItemTemplate: ITrialItemTemplateCreateActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALITEMTEMPLATE_CREATE,
            trialId
        }
    },
    CreateSuccess: ITrialItemTemplateCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialItemTemplateCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialItemTemplate: ITrialItemTemplateValidateActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_VALIDATE,
            formData,
            collectionFormData
        }
    },
    ValidateSuccess: ITrialItemTemplateValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialItemTemplateValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialItemTemplateClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALITEMTEMPLATE_CLEAR,
            propertiesToClear
        }
    },
    Filter: ITrialItemTemplateFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALITEMTEMPLATES_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALITEMTEMPLATE_LOAD = "ACTION_TRIALITEMTEMPLATE_LOAD",
    ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID = "ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID",
    ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS = "ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS",
    ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE = "ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE",

    ACTION_TRIALITEMTEMPLATE_SAVE = "ACTION_TRIALITEMTEMPLATE_SAVE",
    ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS = "ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS",
    ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE = "ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE",

    ACTION_TRIALITEMTEMPLATE_CREATE = "ACTION_TRIALITEMTEMPLATE_CREATE",
    ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS = "ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS",
    ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE = "ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE",

    ACTION_TRIALITEMTEMPLATE_VALIDATE = "ACTION_TRIALITEMTEMPLATE_VALIDATE",
    ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS = "ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS",
    ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE = "ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE",

    ACTION_TRIALITEMTEMPLATE_CLEAR = "ACTION_TRIALITEMTEMPLATE_CLEAR",
    ACTION_TRIALITEMTEMPLATES_FILTER = "ACTION_TRIALITEMTEMPLATES_FILTER";

export interface ITrialItemTemplateLoadAction {
    type: "ACTION_TRIALITEMTEMPLATE_LOAD";
    trialId: number;
}

export interface ITrialItemTemplateLoadActionCreator {
    (trialId: number): ITrialItemTemplateLoadAction;
}

export interface ITrialItemTemplateLoadSuccessAction {
    type: "ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS";
    formData: Dtos.TrialItemTemplate | Dtos.TrialItemTemplate[];
    formDataTrialed: Dtos.Category[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemTemplateLoadSuccessActionCreator {
    (
        formData: Dtos.TrialItemTemplate | Dtos.TrialItemTemplate[],
        formDataTrialed: Dtos.Category[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialItemTemplateLoadSuccessAction;
}

export interface ITrialItemTemplateLoadFailureAction {
    type: "ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemTemplateLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialItemTemplateLoadFailureAction;
}

export interface ITrialItemTemplateLoadByIdAction {
    type: "ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID";
    id: number;
}

export interface ITrialItemTemplateLoadByIdActionCreator {
    (id: number): ITrialItemTemplateLoadByIdAction;
}

export interface ITrialItemTemplateSaveAction {
    type: "ACTION_TRIALITEMTEMPLATE_SAVE";
    formData: Dtos.TrialItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface ITrialItemTemplateSaveActionCreator {
    (
        formData: Dtos.TrialItemTemplate,
        collectionFormData: Dtos.Collection
    ): ITrialItemTemplateSaveAction;
}

export interface ITrialItemTemplateSaveSuccessAction {
    type: "ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS";
    formData: Dtos.TrialItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemTemplateSaveSuccessActionCreator {
    (
        formData: Dtos.TrialItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialItemTemplateSaveSuccessAction;
}

export interface ITrialItemTemplateSaveFailureAction {
    type: "ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialItemTemplateSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialItemTemplateSaveFailureAction;
}

export interface ITrialItemTemplateCreateAction {
    type: "ACTION_TRIALITEMTEMPLATE_CREATE";
    trialId?: number;
}

export interface ITrialItemTemplateCreateActionCreator {
    (trialId?: number): ITrialItemTemplateCreateAction
}

export interface ITrialItemTemplateCreateSuccessAction {
    type: "ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS";
    formData: Dtos.TrialItemTemplate;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialItemTemplateCreateSuccessActionCreator {
    (
        formData: Dtos.TrialItemTemplate,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialItemTemplateCreateSuccessAction;
}

export interface ITrialItemTemplateCreateFailureAction {
    type: "ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialItemTemplateCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialItemTemplateCreateFailureAction;
}

export interface ITrialItemTemplateValidateAction {
    type: "ACTION_TRIALITEMTEMPLATE_VALIDATE";
    formData: Dtos.TrialItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface ITrialItemTemplateValidateActionCreator {
    (
        formData: Dtos.TrialItemTemplate,
        collectionFormData: Dtos.Collection
    ): ITrialItemTemplateValidateAction;
}

export interface ITrialItemTemplateValidateSuccessAction {
    type: "ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS";
    formData: Dtos.TrialItemTemplate;
    formState: Dtos.FormState;
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemTemplateValidateSuccessActionCreator {
    (
        formData: Dtos.TrialItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialItemTemplateValidateSuccessAction;
}

export interface ITrialItemTemplateValidateFailureAction {
    type: "ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialItemTemplateValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialItemTemplateValidateFailureAction;
}

export interface ITrialItemTemplateClearAction {
    type: "ACTION_TRIALITEMTEMPLATE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialItemTemplateClearActionCreator {
    (propertiesToClear?: string[]): ITrialItemTemplateClearAction;
}

export interface ITrialItemTemplateFilterActionCreator {
    (formFilter: IFormFilter): ITrialItemTemplateFilterAction;
}

export interface ITrialItemTemplateFilterAction {
    type: "ACTION_TRIALITEMTEMPLATES_FILTER";
    formFilter: IFormFilter;
}

export type TrialItemTemplateAction =
    ITrialItemTemplateLoadAction |
    ITrialItemTemplateLoadByIdAction |
    ITrialItemTemplateLoadFailureAction |
    ITrialItemTemplateLoadSuccessAction |
    ITrialItemTemplateSaveAction |
    ITrialItemTemplateSaveSuccessAction |
    ITrialItemTemplateSaveFailureAction |
    ITrialItemTemplateCreateAction |
    ITrialItemTemplateCreateSuccessAction |
    ITrialItemTemplateCreateFailureAction |
    ITrialItemTemplateValidateAction |
    ITrialItemTemplateValidateSuccessAction |
    ITrialItemTemplateValidateFailureAction |
    ITrialItemTemplateClearAction |
    ITrialItemTemplateFilterAction;
